import { Injectable } from '@angular/core';
import { AuthService, ConfigService } from '../../../core';
import { ConfigEmpresa, createNomeCliente, createNomeRepresentante, isConfigEmpresaVersaoIntegracaoErp1 } from '../../configuracoes/app/empresa';
import { UsuarioPerfil } from '../../usuario/usuario-perfil';

/** Service que valida os acessos e execuções de funcionalidades dos títulos a receber */
@Injectable({
    providedIn: 'root'
})
export class TituloReceberAuthGuardService {

    constructor(private authService: AuthService,
                private configService: ConfigService) { }

    /** Verifica se pode inserir um novo título a recebcer */
    canInsert(): boolean {
        // Se estiver configurado que não pode inserir títulos
        if (!this.configService.getTituloReceber()?.podeInserir) {
            return false;
        }

        // Somente se for um admin ou usuário do financeiro
        return this.authService.isAdministrador() || this.authService.isFinanceiro();
    }

    /** Verifica se pode editar um título a recebcer */
    canEdit(idTituloReceber: number): boolean {
        // Se estiver configurado que não pode editar títulos
        if (!this.configService.getTituloReceber()?.podeEditar) {
            return false;
        }
        // Se o título a receber não possuir ID então não pode editar
        if (idTituloReceber <= 0) {
            return false;
        }

        // Somente se for um admin ou usuário do financeiro
        return this.authService.isAdministrador() || this.authService.isFinanceiro();
    }


    /** Verifica se pode visualizar o título a receber */
    canVisualizar(): boolean {
        return true;
    }

    /** Verifica se pode imprimir a listagem de títulos */
    canPrintListagem(): boolean {
        return true;
    }

    /** Verifica se pode importar os títulos a receber do ERP V1 */
    canImportErp_v1(): boolean {
        // Somente se for a versão 1
        if (!isConfigEmpresaVersaoIntegracaoErp1(this.configService.getEmpresa())) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

    /** Verifica se pode executar a integração de leitura individual do título com o ERP */
    canImportOneErp_v1(idTituloReceber: number, integradoErp: boolean): boolean {
        if (!idTituloReceber) {
            return false;
        }

        // Somente se for a versão 1
        if (!isConfigEmpresaVersaoIntegracaoErp1(this.configService.getEmpresa())) {
            return false;
        }

        // Se o título a receber ainda não estiver integrado, então não pode sincronizar com o ERP
        if (!integradoErp) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

    /** Verifica se pode importar os títulos a receber do ERP */
    canImportErp(): boolean {
        // Somente se não for a versão 1
        if (isConfigEmpresaVersaoIntegracaoErp1(this.configService.getEmpresa())) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

    /** Verifica se pode importar o títulos a receber do ERP */
    canImportOneErp(idTituloReceber: number, idIntegracaoErp: number): boolean {
        if (!idTituloReceber) {
            return false;
        }

        // Somente se não for a versão 1
        if (isConfigEmpresaVersaoIntegracaoErp1(this.configService.getEmpresa())) {
            return false;
        }

        // Somente se estiver integrado com o ERP
        if (!idIntegracaoErp) {
            return false;
        }


        return this.authService.podeImportarErp();
    }
}
